// extracted by mini-css-extract-plugin
module.exports = {"root":"politica-de-privacidade_root__Lx6U1","title":"politica-de-privacidade_title__3L-uC","text":"politica-de-privacidade_text__AMmtK"};